import React from 'react';

import { ReactComponent as IconSelect } from './assets/icons/select-icon.svg';

import styles from './assets/styles/styles.module.scss';

class Select extends React.Component {
  state = {
    isDropActive: false
  };

  onBlurHandler = () => {
    this.setState({ isDropActive: false });
  };

  onClickHandler = () => {
    this.setState({ isDropActive: !this.state.isDropActive });
  }

  render() {
    const {
      ageValue,
      onAgeChangeHandler,
      ageData
    } = this.props;

    const {
      isDropActive
    } = this.state;

    return (
      <section
        className={`${styles['custom-select']} ${isDropActive ? styles['active-drop'] : ''}`}
        onBlur={this.onBlurHandler}
        onClick={this.onClickHandler}
        tabIndex="-1"
      >
        <span className={styles['current-age']}>
          {ageData.find(item => item.value === ageValue).text}
        </span>
        {isDropActive && (
          <div className={styles['drop-select']}>
            {ageData.map(({text, value}) => (
              <span
                className={styles['drop-select-item']}
                key={value}
                onClick={() => onAgeChangeHandler(value)}
              >
                {text}
              </span>
            ))}
          </div>
        )}
        <IconSelect className={styles['icon-select']} />
      </section>
    );
  };
}

export default Select
